module.exports = __webpack_public_path__ + "static/media/stpierre.15210f18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/seychelles/stpierre.jpg
// module id = 340
// module chunks = 0